enum ActionTypes {
	request = 'ProductHistory.request',
	receive = 'ProductHistory.receive',
	prune = 'ProductHistory.prune',
}

export default ActionTypes;
